export const university_articles = [
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/08/kavika-krishnan-seas-25-on-engineering-student-council-and-crisis-leadership/",
    "article_title": "Kavika Krishnan, SEAS ’25, on Engineering Student Council and crisis leadership",
    "article_authors": "Ria Vashishtha ",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/5QHOAH7MANAGTAHPWF2QC2PITU.jpg?auth=c4d43dbb2b48bb1d450cd0e6fbd1dfc8be24eb95dd0fc0c7b393ac8694dc8402"
  },
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/08/quan-ha-bc-25-on-sga-administrative-accountability-and-campus-healing/",
    "article_title": "Quan Ha, BC ’25, on SGA, administrative accountability, and campus healing",
    "article_authors": "Eden Strananhan ",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/53G2OUBRNFBH3PJY4CFAQY4NOY.jpg?auth=c40503472e2b0efa6a8dbf0d69a3016cf73a9a95d4c2edebe9ffafc46c9b33b5"
  },
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/18/maya-platek-gs-25-reflects-on-her-time-in-the-israel-defense-forces-and-as-gssc-president//",
    "article_title": "Maya Platek, GS ’25, reflects on her time in the Israel Defense Forces and as GSSC president",
    "article_authors": "Emily Pickering ",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/I7WSFRXIMVFTPI3NTLXRVUFDCQ.jpeg?auth=24c7883fc2594b66d5b170fdbd1b0b462bd668d4e35bc84f3fb435cf8ea3c358"
  },
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/06/what-makes-columbia-the-activist-ivy/",
    "article_title": "What makes Columbia the ‘activist Ivy’",
    "article_authors": "Isha Banerjee and Emily Pickering ",
    "image_url": "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/XV63VSQLJNH65AQN2YV7AYB3AQ.jpg"
  },
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/09/maryam-alwan-gs-25-on-heritage-humor-and-having-no-regrets/",
    "article_title": "Maryam Alwan, GS ’25, on heritage, humor, and having no regrets",
    "article_authors": "Daksha Pillai ",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/A35FSHVQ2JCWHHQ43ZD5E5GMC4.jpg?auth=1a6919c59963caed5aa9edfa0ec52d8863ef526b00188dff4fdc834244e53040"
  },
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/18/julian-infante-cc-25-on-abc-presidency-student-wellness-and-community/",
    "article_title": "Julian Infante, CC ’25, on ABC presidency, student wellness, and community",
    "article_authors": "Emily Pickering and Spencer Davis ",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/7RZKG5B5HNEETFDDSQHC6WE524.jpg?auth=9c5e8805fc2d48a213327b18f3840d1cb88903a2135ca803b7165b6f3393d8a1"
  },
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/06/columbia-to-lay-off-nearly-180-researchers-funded-by-federal-grants/",
    "article_title": "Columbia to lay off nearly 180 researchers funded by federal grants",
    "article_authors": "Emily Pickering and Isha Banerjee ",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/3RLJHUJYM5ACRFFP5RVHCVAQGU.jpg?auth=83cf3b24afe3a8ba5c09df7b39e3a4c6be06a292ad85a6487a8b4506fdf4a4a2"
  },
  {
    "article_link": "https://www.columbiaspectator.com/news/2025/05/08/nypd-confirms-78-arrests-at-butler-library-protest-all-released-from-custody/",
    "article_title": "NYPD confirms 78 arrests at Butler Library protest, all released from custody",
    "article_authors": "Tsehai Alfred and Itzel Franco ",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/I5JZPFU5ZJBHDNW744EWSSQY3U.JPG?auth=a9961f3eb8cefdc74a52aef5617d72d5257c299907f6315a5bc6ca0498e12f74"
  }



];

export const ac_articles = [
  {
    "article_link": "https://www.columbiaspectator.com/arts-and-culture/2025/04/29/finding-her-shade-shannon-rhatigan-seas-25-on-nearly-a-decade-of-experience-in-makeup-artistry/",
    "article_title": "Finding her shade: Shannon Rhatigan, SEAS ’25, on nearly a decade of experience in makeup artistry",
    "article_authors": "Taylor Graham",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/XKL57FHTHFCGLF2E3YPSFIIASI.png?auth=eb983487b8c6cd9069ac7ad52cf01e4f36bf2fe4e286de2e84ee40a680ab4263"
  }, 
  {
    "article_link": "https://www.columbiaspectator.com/arts-and-culture/2025/05/06/oliver-schneider-cc-25-and-lucien-beber-turkel-cc-25-on-using-experience-to-fuel-filmmaking/",
    "article_title": "Oliver Schneider, CC ’25, and Lucien Beber-Turkel, CC ’25, on using experience to fuel filmmaking",
    "article_authors": "Ian Romero",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/PHAEX4LVGNAADCNO2MK5SEJNRI.jpeg?auth=d15916e27ad99ca85687ed7ffefc6b0ed428b85f000c33985436c557268e49df"
  },
  {
    "article_link": "https://www.columbiaspectator.com/arts-and-culture/2025/04/09/ashley-albinus-bc-25-on-the-trade-secrets-of-improv-and-building-a-career-in-comedy/",
    "article_title": "Ashley Albinus, BC ’25, on the trade secrets of improv and building a career in comedy",
    "article_authors": "Poppy Needham",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/WKJP3EDXSFGQPNTLOO3SXQYTUA.png?auth=e29d9bf19bb8e3eaea2901f0fbf62404e20d4b0808ff46cdf78ae7c239ac91b3"
  },
  {
    "article_link": "https://www.columbiaspectator.com/arts-and-culture/2025/05/12/maya-shkolnik-cc-25-on-photography-psychoanalysis-and-protest-art/",
    "article_title": "Maya Shkolnik, CC ’25, on photography, psychoanalysis, and protest art",
    "article_authors": "Beatrice Moyers",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/XDYBSIPJIBGPJF7ESUXQR2IOGU.png?auth=13937d9dea41657125536556fd644c95d4e4594dc0d0761638ba574051149e86"
  },
  {
    "article_link": "https://www.columbiaspectator.com/arts-and-culture/2025/05/04/catherine-herrera-cc-25-on-musical-theater-and-her-love-for-sheep/",
    "article_title": "Catherine Herrera, CC ’25, on musical theater and her love for sheep",
    "article_authors": "Nadia Knoblauch",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/BRVIVWR3NVASVJVXXP6ANP222Y.jpg?auth=95a59749dad8cbe180094113a8a6b43cec875458a70efb17abe1aa294b70d47e"
  },
];

export const audio_articles = [

];

export const sports_articles = [
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/07/kitty-henderson-cc-25-on-leadership-and-breaking-records/",
    article_title: "Kitty Henderson, CC ’25, on leadership and breaking records",
    article_authors: "Arielle Rieder",
    image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/GRYU72ZGPRAUHEJJBK63SU5BDY.jpeg"
  },
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/05/cecelia-collins-cc-25-on-transfer-and-triumph/",
    article_title: "Cecelia Collins, CC ’25, on transfer and triumph",
    article_authors: "Jillian Prunty",
    image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/IGSQKAT2LFCQ7CNPIRJL3UW77Q.jpeg"
  },
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/06/emily-macdonald-cc-25-leaves-her-legacy-in-columbias-record-books/",
    article_title: "Emily MacDonald, CC ’25, leaves her legacy in Columbia’s record books",
    article_authors: "Emily Michaelsen",
    image_url: "https://www.columbiaspectator.com/resizer/v2/TXAQMGZYRRHLNH3KTG3RIRNLSM.jpg?auth=3e691bef29ce1198b62e0f0a698ae65f1d5482feef6ca7bb5a998c5f36424028"
  },
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/08/max-westphal-cc-25-on-tennis-teamwork-and-transformation/",
    article_title: "Max Westphal, CC ’25, on tennis, teamwork, and transformation",
    article_authors: "Diane Lang",
    image_url: "https://www.columbiaspectator.com/resizer/v2/B5P3NE3GXFEP7JKB4LMCG52NE4.jpeg?auth=76a144124fd5ead79a8979b42a6c23664ef60a78c63adb61f00892a30b0edda4"
  },
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/10/geronimo-rubio-de-la-rosa-cc-25-ends-his-columbia-journey-right-at-home/",
    article_title: "Geronimo Rubio De La Rosa, CC ’25, ends his Columbia journey right at home",
    article_authors: "Benjamin Rubin",
    image_url: "https://www.columbiaspectator.com/resizer/v2/QLUAWPULRBCD3ATELWEM23KQEU.jpg?auth=baf035ec8b82ef450559c85691d5218690162319cef370d9bcbc1d6d827c4167"
  },
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/15/diver-macy-pine-cc-25-defines-her-own-way-to-lead-with-joy/",
    article_title: "Diver Macy Pine, CC ’25, defines her own way to lead with joy",
    article_authors: "Kaya Quebada",
    image_url: "https://www.columbiaspectator.com/resizer/v2/IQSA7RURIRFVTMFT4NCHSVXCX4.jpg?auth=1bc1257dc9b3fc1854bc7bc72b95a6048c97774c7d6f8c76d50c9e9fbc0cd357"
  },
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/07/a-second-family-fatima-keita-cc-25-on-finding-community-on-the-tennis-court/",
    article_title: "‘A second family’: Fatima Keita, CC ’25, on finding community on the tennis court",
    article_authors: "Holden Lombardo",
    image_url: "https://www.columbiaspectator.com/resizer/v2/ERXWTT6CNRGO5BDRWOLLNIPKTQ.jpg?auth=384c8d4a726f8606b7e687fba4fe8d789a3efb0c2b97d63b5a616f25ffda0fcc"
  },
  {
    article_link: "https://www.columbiaspectator.com/sports/2025/05/17/phoebe-anderson-cc-24-runs-with-purpose-not-just-pace/",
    article_title: "Phoebe Anderson, CC ’24, runs with purpose, not just pace",
    article_authors: "Ashley Flores",
    image_url: "https://www.columbiaspectator.com/resizer/v2/6LKTFT2KEFFSTGT5MKJ5TYW6DA.jpeg?auth=4c533f0047d786c2e6ca076c4c262ddd0531658221b14e934279b3cf9af8440f"
  }
];

export const crossword_articles = [
  {
    article_link: "https://www.columbiaspectator.com/multimedia/2025/05/07/commencement-2025/",
    article_title: "Commencement 2025",
    article_authors: "Molly Durawa and Reda Shaikh",
    image_url: "https://www.columbiaspectator.com/resizer/v2/2MDWS73TIRDJROK4M2MGZ7UKAE.png?auth=60168836f84101dfef1dc0c5285720419182d4e5420adcc1595abfac4f62b1c0"
  }
];

export const opinion_articles = [
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/18/the-view-from-here/",
    article_title: "The view from here",
    article_authors: "Isabella Ramirez",
    image_url: "https://www.columbiaspectator.com/resizer/v2/FAZIYAPOA5FHTO74GLVA3FCNEY.jpg?auth=525dee4d0893fae21e8246c442a3d7ac1dc55d47edeb8a0c0680b2f6c7164075"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/13/on-passing-through/",
    article_title: "On passing through",
    article_authors: "Esha Karam",
    image_url: "https://www.columbiaspectator.com/resizer/v2/JZQ6AXBOD5CJ7L5RQN7NRPXLXY.jpg?auth=5b2a75685a7ca46c8b2d7fc9ee8547c3ce988e3b3f8254f7e44d33310d8de158"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/01/i-spent-four-years-at-spectator-and-all-i-wrote-was-this-column/",
    article_title: "I spent four years at Spectator and all I wrote was this column",
    article_authors: "Yvin Shin",
    image_url: "https://www.columbiaspectator.com/resizer/v2/AO2C3ZMQNJE3JHE3KHFAQH3DQQ.jpeg?auth=83ee33c8c6a534c4d0ad1cd9fdef94450006ff9918069f0663b8ae702b5429a5"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/19/in-focus-four-years-in-13-photos/",
    article_title: "In Focus: Four years in 13 photos",
    article_authors: "Judy Goldstein",
    image_url: "https://www.columbiaspectator.com/resizer/v2/NGYAFYDH5NFORITFLT577W6JGQ.JPEG?auth=c2d1878425bc6584c2178abbbcc5959213f8a89c43e2f8d8d4b67efe8477755b"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/18/on-talking-to-strangers-a-love-letter-to-city-news/",
    article_title: "On talking to strangers: A love letter to City News",
    article_authors: "Amira Mckee",
    image_url: "https://www.columbiaspectator.com/resizer/v2/JWCZP5CXZFCJTHAVDORXHOUH3Q.jpg?auth=c31db75f0043400deb7d99dcd1e9d29a88994590322b8430e00b1f99d5840fff"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/20/into-the-deep-end-bones-and-all/",
    article_title: "Into the deep end, bones and all",
    article_authors: "Emily Chen",
    image_url: "https://www.columbiaspectator.com/resizer/v2/2YUHCPB6ZZDCLNZV347HWYUBUI.jpg?auth=04661467627d9fd4078c897bd240f8d0bc6f01d88f8e1e5e4122946e5157ea76"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/06/on-criticism/",
    article_title: "On criticism",
    article_authors: "Kelsea Petersen",
    image_url: "https://www.columbiaspectator.com/resizer/v2/UNTM6ND74FBJTPSSCDYJA7H5XI.jpg?auth=c77ea8404063d4a76a462f2bff29f9b395a217176b9f4eb3680ff67eb8e65716"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/20/running-and-walking-or-goodbye-to-all-that/",
    article_title: "Running and Walking, or ‘Goodbye to All That’",
    article_authors: "Esther Sun",
    image_url: "https://www.columbiaspectator.com/resizer/v2/7FY5T5C2HFHGDACCHXFWQ3XZTY.jpg?auth=3fbbf7c2bacd509f75c184bfa185c50641700d91c3dc6560e8ccf1f7cbf0c8e6"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/18/a-farewell-letter-from-a-former-editor/",
    article_title: "A (farewell) letter from a (former) editor",
    article_authors: "Kenneth Roedl",
    image_url: "https://www.columbiaspectator.com/resizer/v2/EICM53SCFJDFDMFFBQYKXZDQCY.jpeg?auth=55b3ab0f37c25d7b89df4cc93910725fc1610c40210945448fa2089f2f66a22f"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/18/a-good-time-not-a-long-time/",
    article_title: "A good time, not a long time",
    article_authors: "Takashi Williams",
    image_url: "https://www.columbiaspectator.com/resizer/v2/E3KRAN7N2JH3NFUCJCQAIYKE6U.jpeg?auth=6377bf4d17fb6441a25e654dec78653c2c123c008d11046f422684571fc7f8cc"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/18/on-promises-kept/",
    article_title: "On promises kept",
    article_authors: "Sydney Goldson",
    image_url: "https://www.columbiaspectator.com/resizer/v2/V3GCMQHGS5HYLCBLOUH7PYHBEM.jpeg?auth=12029b92f81e5386b41cf3e3696d4f646fc7432960518dd9d58d9a2f644065a7"
  },
  {
    article_link: "https://www.columbiaspectator.com/opinion/2025/05/20/on-devotion-and-sunk-cost-fallacies/",
    article_title: "On Devotion and sunk-cost fallacies",
    article_authors: "Ariana Eftimu",
    image_url: "https://www.columbiaspectator.com/resizer/v2/N56QFC7WOFHUNG24CWBCC2T55U.jpeg?auth=6a45ccad87dcaa35732247d41bbf70cc5516e9150730aae0624164a90aa9119f"
  }
];


export const spectrum_articles = [
  {
    "article_link": "https://www.columbiaspectator.com/spectrum/2025/05/04/a-farewell-to-the-class-of-2025/",
    "article_title": "A farewell to the Class of 2025",
    "article_authors": "Loyca Jean",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/FGIOYCMVVZGMRMMQ76TOD7NOBA.jpeg?auth=ae8753911869d3b411b6f58c082dac5641ce7ff9eeba2d75669c59ddcdfe916c"
  },
  {
    "article_link": "https://www.columbiaspectator.com/spectrum/2025/04/29/open-when-youre-saying-goodbye-to-dorm-life/",
    "article_title": "Open when: You’re saying goodbye to dorm life",
    "article_authors": "Isabella O’Connor",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/EBKWI4WCYNG6LKVNI2GDGIOCZQ.jpg?auth=81a1505001df1f6da9245886ee34d8a20e92b434e74815af2ae43c22c340ea49"
  },
  {
    "article_link": "https://www.columbiaspectator.com/spectrum/2025/04/28/spectrums-graduation-playlist/",
    "article_title": "Spectrum’s Graduation Playlist",
    "article_authors": "Ally Sepe",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/3KGPY7WYVBFKZEPEFZ4UCLR6ZU.jpeg?auth=5faead96a5642d50ae6a6eb6d1eda1bc4c66567c0a50abe145a73889810de9f2"
  },
  {
    "article_link": "https://www.columbiaspectator.com/spectrum/2025/05/05/open-when-youre-saying-goodbye-to-your-senior-friends/",
    "article_title": "Open when: You are saying goodbye to your senior friends",
    "article_authors": "Terran Garner",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/3UWDDJCA5NGXTHYYXI7JHJNCMQ.jpeg?auth=779447f3b73f32156e75ae21a252abb86590b9243a8b6b3af51be72b2949a69c"
  },
  {
    "article_link": "https://www.columbiaspectator.com/spectrum/2025/05/04/open-when-you-didnt-meet-your-soulmate-at-columbia/",
    "article_title": "Open When: You didn’t meet your soulmate at Columbia",
    "article_authors": "Suhani Arora",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/JT6SMHKSVRCV5EARNZU4XBBT7M.png?auth=846cf255c65a97592fbbfab6b77b2acc349c52d03bee8b7f4d43d78e1963e20b"
  },
  {
    "article_link": "https://www.columbiaspectator.com/spectrum/2025/04/28/open-when-youre-not-sure-what-to-do-after-graduation/",
    "article_title": "Open when: you are not sure what to do after graduation",
    "article_authors": "Isabella O’Connor",
    "image_url": "https://www.columbiaspectator.com/resizer/v2/HKSCZNQUYNF47ANYCZXVVKZ2HA.png?auth=168a98f7d34513534ed6f54983af0d52e7ba1a6cbcaa2e09c2a6f451b6043126"
  },
  {
    "article_link": "https://www.youtube.com/watch?v=IR9q-_oc99U",
    "article_title": "25 seniors from the class of 2025 reflect on their time at Columbia",
    "article_authors": "Ashlynne Graham, Vi Tran, Alexandra Sepe, Liz Backus, and Chris Perez",
    "image_url":"https://cloudfront-us-east-1.images.arcpublishing.com/spectator/IDPM7M7K6JD6JPVPD55V6RY5HA.jpg//resizer/v2/IDPM7M7K6JD6JPVPD55V6RY5HA.jpg?auth=19aaa1471d62ce6ddda06272593a6a518f4b5ac8cf8587aad320d8d492753e52"
  }
];
